export const SAFE_MAX_CANVAS_DIMENSION = 8192;

export interface CanvasSurfaceSize {
  width: number;
  height: number;
}

export function resolveCanvasSurfaceSize(canvas: HTMLCanvasElement): CanvasSurfaceSize {
  const parent = canvas.parentElement;
  const viewportWidth = window.innerWidth || SAFE_MAX_CANVAS_DIMENSION;
  const viewportHeight = window.innerHeight || SAFE_MAX_CANVAS_DIMENSION;
  const width = Math.min(parent?.clientWidth || viewportWidth, viewportWidth, SAFE_MAX_CANVAS_DIMENSION);
  const height = Math.min(parent?.clientHeight || viewportHeight, viewportHeight, SAFE_MAX_CANVAS_DIMENSION);
  return {
    width: Math.max(1, Math.floor(width)),
    height: Math.max(1, Math.floor(height)),
  };
}
